module.exports = __webpack_public_path__ + "static/img/win11_2.1352c4c.png";